var _Path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function SvgPlusIcon(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Circle, {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    fill: props.color
  }), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M13.53 8.024c.221 0 .333.111.333.333v.924c0 .222-.112.333-.334.333H9.375c-.086 0-.129.043-.129.128v4.052c0 .223-.11.334-.333.334H7.99c-.223 0-.334-.111-.334-.334V9.742c0-.085-.042-.128-.128-.128H3.373c-.222 0-.333-.111-.333-.333v-.924c0-.222.111-.333.333-.333h4.155c.086 0 .128-.043.128-.128V3.639c0-.223.111-.334.334-.334h.923c.222 0 .333.111.333.334v4.257c0 .085.043.128.129.128h4.154z",
    fill: "#fff"
  })));
}

export default SvgPlusIcon;